import React from 'react';
import Particles from './ListExport';
import {Title, Icon} from './../Basics';
import {Motion, spring} from 'react-motion';
import ParticleInstance from './../Particles/ParticleInstance';

import './Remaining.css';

const RemainingList = ({particleKeys, read, expandRemaining, expandedParticle, height, lang}) => {
  const remaining = particleKeys.filter(particleKey => read.indexOf(particleKey) < 0);
  const expandedContent = Particles[expandedParticle] ? Particles[expandedParticle][lang] : null;
  return  <div className='Remaining--ListWrapper' style={{height: height}}>
    <ul className='Remaining--List'>
      {remaining.map( (key, i) => {
        const {defaultTeaser, type, duration} = Particles[key][lang];
        const isExpanded = expandedParticle === key;
        return <li
          key={i}
          onClick={()=> !isExpanded ? expandRemaining(key) : null}
          className='Remaining__ListItem'>
          <div className='Particle__meta'><Icon type={type}/>{type} {duration}</div>
          <Title>{defaultTeaser}</Title>
        </li>
        })
      }
    </ul>
    <div className='Remaining--Detail'>
      {expandedContent && (<div>
            <div className='Particle__meta'><Icon type={expandedContent.type}/>{expandedContent.type} {expandedContent.duration}</div>
            <ParticleInstance content={expandedContent} isExpanded={false} keepTitle={true}/>
          </div>)}
    </div>
  </div>
}

const Remaining = ({
  read,
  toggleRemaining,
  expandRemaining,
  expandedParticle,
  expanded,
  textRemaining,
  textAllRead,
  lang,
  height=0
}) => {
  const readKeys = Object.keys(read);
  const particleKeys = Object.keys(Particles);

  const amountRead = readKeys.length;
  const amountRemaining = particleKeys.length;

  const remaining = amountRemaining - amountRead;

  return (
    <section>
      <div className='Remaining__header'>
        { expandedParticle &&
          <div className='Remaining__back'
          onClick={() => {
            expandRemaining(expandedParticle, true)
            expandRemaining(null, false)
          }}/>
        }
        <div>Particles</div>
        <small>{remaining} {textRemaining}</small>
        { !expandedParticle &&
          <div className='Remaining__close' onClick={toggleRemaining}/>  
        }
      </div>
      { remaining <= 0 &&
        <div className='Remaining__empty' style={{height: height}}>
          <b>😎</b>
          <span>{textAllRead}</span>
        </div>
      }
      { remaining > 0 &&
        <Motion defaultStyle={{left: 0}} style={{left: spring(expandedParticle ? 100 : 0)}}>
          { interpolated =>
            <div style={{ maxHeight: height, transform: `translateX(${-interpolated.left}%)` }}>
              <RemainingList
                height={height}
                read={readKeys}
                lang={lang}
                particleKeys={particleKeys}
                expandedParticle={expandedParticle}
                expandRemaining={expandRemaining}
              />
            </div>
          }
        </Motion>
      }
    </section>
  )
}

export default Remaining;



/** WEBPACK FOOTER **
 ** ./src/Particles/Remaining.js
 **/